const Allcoin = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 32 32' fill='none'>
			<path
				d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z'
				fill='#EF0027'
			/>
			<path
				d='M10.966 4.95642L3.75 3.62842L7.5475 13.1844L12.839 6.73742L10.966 4.95642ZM10.85 5.54142L11.954 6.59092L8.935 7.13742L10.85 5.54142ZM8.279 7.02792L5.097 4.38892L10.298 5.34592L8.279 7.02792ZM8.0525 7.49492L7.5335 11.7849L4.736 4.74342L8.0525 7.49442V7.49492ZM8.5325 7.72242L11.876 7.11742L8.041 11.7889L8.5325 7.72242Z'
				fill='white'
			/>
			<path
				d='M23 23C27.9706 23 32 18.9706 32 14C32 9.02944 27.9706 5 23 5C18.0294 5 14 9.02944 14 14C14 18.9706 18.0294 23 23 23Z'
				fill='#627EEA'
			/>
			<path d='M23.2802 7.25V12.2394L27.4972 14.1237L23.2802 7.25Z' fill='white' fillOpacity='0.602' />
			<path d='M23.2801 7.25L19.0625 14.1237L23.2801 12.2394V7.25Z' fill='white' />
			<path d='M23.2802 17.3569V20.7471L27.5 14.9089L23.2802 17.3569Z' fill='white' fillOpacity='0.602' />
			<path d='M23.2801 20.7471V17.3564L19.0625 14.9089L23.2801 20.7471Z' fill='white' />
			<path d='M23.2802 16.5723L27.4972 14.1237L23.2802 12.2405V16.5723Z' fill='white' fillOpacity='0.2' />
			<path d='M19.0625 14.1237L23.2801 16.5723V12.2405L19.0625 14.1237Z' fill='white' fillOpacity='0.602' />
			<path
				d='M11 32C16.5228 32 21 27.5228 21 22C21 16.4772 16.5228 12 11 12C5.47715 12 1 16.4772 1 22C1 27.5228 5.47715 32 11 32Z'
				fill='#F7931A'
			/>
			<path
				d='M15.4931 20.7625C15.6894 19.4525 14.6913 18.7481 13.3275 18.2781L13.77 16.5031L12.69 16.2344L12.2588 17.9625C11.975 17.8912 11.6838 17.825 11.3931 17.7587L11.8275 16.0194L10.7475 15.75L10.305 17.5244C10.07 17.4706 9.83877 17.4181 9.61502 17.3619L9.61627 17.3562L8.12627 16.9844L7.83877 18.1381C7.83877 18.1381 8.64065 18.3219 8.62377 18.3331C9.06127 18.4425 9.14002 18.7319 9.1269 18.9619L8.62314 20.9837C8.65314 20.9912 8.6919 21.0025 8.73565 21.0194L8.62127 20.9913L7.91502 23.8237C7.86127 23.9562 7.72564 24.1556 7.41939 24.08C7.43064 24.0956 6.6344 23.8844 6.6344 23.8844L6.09814 25.1206L7.50439 25.4713C7.76564 25.5369 8.02189 25.6056 8.27377 25.67L7.8269 27.465L8.90627 27.7337L9.34877 25.9587C9.64377 26.0381 9.93002 26.1119 10.21 26.1819L9.76877 27.9494L10.8488 28.2181L11.2956 26.4269C13.1381 26.7756 14.5231 26.635 15.1063 24.9688C15.5763 23.6275 15.0831 22.8531 14.1138 22.3488C14.82 22.1863 15.3513 21.7219 15.4931 20.7625ZM13.0244 24.2238C12.6913 25.5656 10.4319 24.84 9.69939 24.6581L10.2931 22.28C11.0256 22.4631 13.3738 22.825 13.0244 24.2238ZM13.3588 20.7431C13.0544 21.9638 11.1744 21.3431 10.565 21.1913L11.1025 19.035C11.7119 19.1869 13.6763 19.47 13.3588 20.7431Z'
				fill='white'
			/>
		</svg>
	);
};

export default Allcoin;
